import { render, staticRenderFns } from "./consentUser.vue?vue&type=template&id=75429e52&scoped=true&"
import script from "./consentUser.vue?vue&type=script&lang=js&"
export * from "./consentUser.vue?vue&type=script&lang=js&"
import style0 from "./consentUser.vue?vue&type=style&index=0&id=75429e52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75429e52",
  null
  
)

export default component.exports